import React, { useRef, useState } from "react";

import { useActionSheet } from "@/components/hooks/useActionSheet";
import { t, tc } from "@/localization";
import UploadV2NoticeView from "./UploadV2NoticeView";
import { useUploadV2 } from "./useUploadV2";

// Manage Video, web: the resume offer asks for the file with a hidden file
// input (see UploadV2NoticeView).
const UploadV2Notice = ({ event, style }) => {
  const uploadV2 = useUploadV2(event?.slug);
  const { showActionSheetWithOptions } = useActionSheet();
  const inputRef = useRef(null);
  const [pickError, setPickError] = useState(null);

  const onPick = (pickEvent) => {
    const file = pickEvent.target.files?.[0];
    pickEvent.target.value = "";
    if (!file) return;
    const result = uploadV2.resumeWithFile(file, { event });
    setPickError(result?.error || null);
  };

  const onDiscard = () =>
    showActionSheetWithOptions(
      {
        options: [t("Discard upload"), tc("upload", "Keep it")],
        cancelButtonIndex: 1,
        destructiveButtonIndex: 0,
        title: t("Discard this unfinished upload?"),
        message: t("The part already uploaded will be deleted."),
      },
      (buttonIndex) => {
        if (buttonIndex === 0) uploadV2.cancel();
      }
    );

  return (
    <UploadV2NoticeView
      uploadV2={uploadV2}
      onResume={() => inputRef.current?.click()}
      onDiscard={onDiscard}
      pickError={pickError}
      style={style}
    >
      <input
        ref={inputRef}
        type="file"
        accept="video/*"
        style={{ display: "none" }}
        onChange={onPick}
      />
    </UploadV2NoticeView>
  );
};

export default UploadV2Notice;
